<template>
  <div>
    <!--  header-->
    <a-page-header style="width: 105%; margin-left: -20px" title="">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="rocket" />
            <span>{{ $t("message.txtManagement.title1") }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="book" />
            <span>{{ $t("message.strategyPushMgt.DelivStrat") }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <div class="page-title">{{ $t("message.strategyPushMgt.DelivStrat") }}</div>

    <div class="search">
      <a-tabs v-model="pageTab" @change="onSearch" :animated="false">
        <a-tab-pane key="all" :tab="$t('message.userAnalysis.all')"></a-tab-pane>
        <a-tab-pane key="run" :tab="$t('message.strategyPushMgt.InProgress')"></a-tab-pane>
        <a-tab-pane key="wait" :tab="$t('message.strategyPushMgt.ToBeStarted')"></a-tab-pane>
        <a-tab-pane key="over" :tab="$t('message.strategyPushMgt.Expired')"></a-tab-pane>
        <a-tab-pane key="stop" :tab="$t('message.strategyPushMgt.Stopped')"></a-tab-pane>

      </a-tabs>

      <a-card class="mb16">
        <a-row :gutter="32">
          <a-col class="gutter-row" :span="7">
            <a-input :size="$globalSize" v-model="strategyName"
              :placeholder="$t('message.strategyManagement.strategyLabel2')">
              <div slot="addonBefore" style="margin-right: 20px">
                {{ $t("message.strategyManagement.strategyLabel2") }}:
              </div>
            </a-input>
          </a-col>
          <a-col class="gutter-row" :span="7">
            <a-input :size="$globalSize" :placeholder="$t('message.strategyManagement.strategyLabel1')"
              v-model="strategyId">
              <div slot="addonBefore" style="margin-right: 20px">
                {{ $t("message.strategyManagement.strategyLabel1") }}:
              </div>
            </a-input>
          </a-col>
          <a-col class="gutter-row" :span="10">
            <a-button class="my-btn" :size="$globalSize" style="float: right;" type="primary"
              :disabled="strategyListLoading" @click="onSearch">{{ $t("message.commonUsage.search") }}</a-button>
          </a-col>
        </a-row>
      </a-card>
      <div class="flex justify-content-end">
        <a-button :size="$globalSize" type="primary" class="my-btn" icon="plus-circle" slot="tabBarExtraContent" @click="addActivity"
          :disabled="$store.getters.hasPermission($store.state.LIMIT_CONSTANTS.USE_CASE_LIMIT)">
          {{ $t("message.strategyPushMgt.createStrategy") }}
        </a-button>
      </div>
      <div class="content mt16">
        <a-card>
          <a-table :loading="strategyListLoading" class="components-table-demo-nested" :scroll="{ x: 1500 }"
            :columns="tableColumns" :data-source="tableData" :pagination="false" rowKey="strategy_id"
            @expand="expandRow">
            <a slot="operation" slot-scope="text, record">
              <a-tooltip v-if="record.strategy_status !== '2'" placement="top">
                <template slot="title">
                  <span>{{ $t("message.strategyPushMgt.AddDelivery") }}</span>
                </template>
                <a-button type="primary" shape="circle" class="toufang-btn-icon"
                  :disabled="$store.getters.hasPermission($store.state.LIMIT_CONSTANTS.ACTION_LIMIT)"
                  @click="addAction(record)" />
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>{{
                    $t("message.strategyManagement.operateTip1")
                    }}</span>
                </template>
                <a-button type="primary" class="detail-btn-icon" shape="circle" @click="editActivity(record, 'view')" />
              </a-tooltip>

              <a-button type="primary" shape="circle" class="delete-btn-icon" @click="delActivity(record)" />
            </a>
            <template slot="strategy_name" slot-scope="text">
              <a-popover trigger="hover">
                <template slot="content">
                  <p>{{ text }}</p>
                </template>
                <div v-if="text.length > 20">{{ text.substr(0, 20) }} ...</div>
                <div v-else>{{ text }}</div>
              </a-popover>
            </template>
            <template slot="expiry_start_date" slot-scope="text, recordAll">
              {{ showTime(text) }} ~ {{ showTime(recordAll.expiry_end_date) }}
            </template>
            <template slot="strategy_status" slot-scope="text, recordAll">
              {{ showStatus(recordAll) }}
            </template>
            <template slot="create_time" slot-scope="text">
              {{
                convertToDefaultTimezone(showTime(text, "yyyy-MM-dd hh:mm:ss"))
              }}
            </template>
            <template slot="status" slot-scope="text, record">
              <a-tooltip placement="top" v-if="record.strategy_status !== '2'">
                <template slot="title">
                  <span>{{
                    text
                      ? $t("message.userGroupList.enable")
                      : $t("message.userGroupList.disable")
                  }}</span>
                </template>
                <a-switch :checked="!!text" @click="disabledBtn(record)" />
              </a-tooltip>
            </template>
            <a-table slot="expandedRowRender" slot-scope="operation" :columns="innerColumns" :scroll="{ x: 1000 }"
              :data-source="actionListMap[operation.strategy_id]" :pagination="false" rowKey="id"
              :loading="operation.loadingExpanded">
              <template slot="push_time" slot-scope="text">
                {{ text }}
              </template>

              <template slot="delivered" slot-scope="text,record">
                {{ text }}
                <span style="
                  background-color: var(--main-color);
                  border-radius: 10px;
                  transform: 'rotateZ(90deg)';
                   cursor: 'pointer'
                " @click="showDeliveredModal(record)">
                  <a-icon style="color:white" type="more" />
                </span>
              </template>
              <span slot="operation" slot-scope="text, record" class="table-operation">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>{{ $t("message.strategyPushMgt.Details") }}</span>
                  </template>
                  <a-button type="primary" shape="circle" class="detail-btn-icon"
                    @click="editBehavior(record, operation, 'view')" />
                </a-tooltip>

                <a-tooltip placement="top" v-if="operation.strategy_status !== '2'">
                  <template slot="title">
                    <span>{{ $t("message.commonUsage.edit") }}</span>
                  </template>
                  <a-button type="primary" shape="circle" class="edit-btn-icon"
                    @click="editBehavior(record, operation, 'edit')" />
                </a-tooltip>

                <a-tooltip placement="bottom" v-if="operation.strategy_status !== '2'">
                  <template slot="title">
                    <span>{{ $t("message.commonUsage.delete") }}</span>
                  </template>
                  <a-tooltip placement="top">
                    <a-button type="primary" shape="circle" class="delete-btn-icon"
                      @click="deleteBehavior(record)"></a-button>
                  </a-tooltip>
                  <!-- <a-button  :size="$globalSize"  v-else :disabled="true" type="primary" shape="circle" icon="delete"></a-button> -->
                </a-tooltip>
              </span>
            </a-table>
          </a-table>
          <my-pagination ref="myPaginationRef" :total="tableTotalCount" @change="getStrategyList"></my-pagination>
        </a-card>
      </div>

      <!-- 编辑提醒 -->
      <a-modal v-model="editWarmShow" :title="curMode === 'view'
        ? $t('message.strategyPushMgt.ViewReminder')
        : $t('message.strategyPushMgt.EditReminder')
        " width="800px">
        <template slot="footer">
          <my-button :size="$globalSize" key="submit" type="primary" v-if="!onlyView" :disabled="disabledSubmitBtn"
            @click="saveStrategyAction">
            {{ $t("message.strategyPushMgt.SaveReminder") }}
          </my-button>
          <a-button :size="$globalSize" type="primary" @click="editWarmShow = false">
            {{ $t("message.commonUsage.cancel") }}
          </a-button>
        </template>
        <a-form :label-col="labelCol" :wrapper-col="wrapCol">
          <a-form-item :label="$t('message.strategyPushMgt.SelectReminderChannel')">
            <a-select :size="$globalSize" disabled v-model="editWarmForm.action_type" style="width: 135px"
              :placeholder="$t('message.strategyStore.selectChoose')">
              <a-select-option v-for="item in plainOptions" :key="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('message.pushStrategy.pushTemplateSelection')">
            <a-radio-group :size="$globalSize" :disabled="onlyView" v-model="appModel">
              <a-radio value="1" disabled>{{
                $t("message.pushStrategy.smartCopywriting")
                }}</a-radio>
              <a-radio value="2">{{
                $t("message.pushStrategy.customizedCopy")
                }}</a-radio>
            </a-radio-group>
          </a-form-item>

          <template v-if="appModel == '2'">
            <a-form-item :label="$t('message.pushStrategy.pushMessage')">
              <a-select :size="$globalSize" key="bb" label-in-value show-search option-filter-prop="children"
                :filter-option="txtFilterOption" @change="tabChangeXun"
                :placeholder="$t('message.pushStrategy.chooseText')" v-model="textValue" :disabled="onlyView">
                <a-select-option v-for="item in push_txts" :key="item.id" :value="item.id" :label="item.content_name"
                  :title="item.content_detail">
                  {{ item.content_name }} ({{ item.id }})
                </a-select-option>
              </a-select>
            </a-form-item>
          </template>
          <a-form-item :label="$t('message.pushStrategy.reminderTime')">
            <div class="flex justify-space-between align-item-center grid-gap-16">
              <a-select style="flex: 1" :size="$globalSize" :disabled="onlyView" v-model="editWarmForm.push_time"
                :placeholder="$t('message.pushStrategy.pleaseSelectTime')" @change="handleActionTimeChange"
                :options="reminderTimeOpt">
              </a-select>
              <div style="padding-right: 16px">
                {{ curEditStrategy.time_zone }}
              </div>
            </div>
          </a-form-item>
          <a-row v-if="showTimeZoneWarning">
            <a-col :span="labelCol.span"></a-col>
            <a-col :span="wrapCol.span">
              <a-tag color="red" style="height: 40px; width: 100%; line-height: 40px">{{
                $t("message.strategyManagement.timeZoneWarning") }}</a-tag>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <!-- 策略投放信息   -->
      <a-modal v-model="throwVisible" width="770px" :maskClosable="false" destroyOnClose>
        <template slot="title">
          <div style="text-align: center">
            {{ $t("message.strategyStore.strategyInformation") }}
          </div>
        </template>
        <template slot="footer">
          <a-button :size="$globalSize" type="primary" @click="handleOk7" v-if="!onlyView" :loading="loading_step"
            :disabled="disabledSubmitBtn">
            {{ $t("message.commonUsage.save") }}
          </a-button>
          <a-button :size="$globalSize" @click="throwVisible = false" v-else>
            {{ $t("message.commonUsage.cancel") }}
          </a-button>
        </template>
        <a-spin :spinning="useCaseDetailLoading" size="large">

          <a-form-model :model="strategyMain" ref="deliveryInformationRuleForm" :rules="deliveryInformationRules"
            :label-col="labelCol" :wrapper-col="wrapCol">
            <a-form-model-item :label="$t('message.strategyManagement.strategyLabel2')" prop="strategy_name">
              <a-input :size="$globalSize" :disabled="onlyView"
                :placeholder="$t('message.strategyStore.pleaseEnterName')" type="text"
                v-model="strategyMain.strategy_name" style="width: 100%" />
            </a-form-model-item>
            <a-form-model-item :label="$t('message.strategyStore.periodicdelivery')" prop="strategy_type">
              <a-radio-group :size="$globalSize" :disabled="onlyView" v-model="strategyMain.strategy_type">
                <a-radio value="SingleTime">
                  {{ $t("message.strategyStore.singleTime") }}</a-radio>
                <a-radio value="Cycle">
                  {{ $t("message.strategyStore.cycle") }}</a-radio>
              </a-radio-group>
            </a-form-model-item>

            <a-form-model-item :label="$t('message.strategyStore.timezone')" prop="time_zone">
              <a-select v-model="strategyMain.time_zone" :disabled="onlyView" :size="$globalSize">
                <a-select-option v-for="timezone in timezoneList" :key="timezone.tz" :value="timezone.tz">
                  {{ `${timezone.city}(${timezone.offset})` }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="$t('message.strategyManagement.startDate')" prop="expiry_start_date">
              <a-date-picker :size="$globalSize" v-model="strategyMain.expiry_start_date" format="YYYY-MM-DD"
                style="width: 100%" :disabled="onlyView" />
            </a-form-model-item>
            <a-row v-if="showTimeZoneWarning" style="margin-bottom: 16px">
              <a-col :span="labelCol.span"></a-col>
              <a-col :span="wrapCol.span">
                <a-tag color="red" style="height: 40px; width: 100%; line-height: 40px">{{
                  $t("message.strategyManagement.timeZoneWarning") }}</a-tag>
              </a-col>
            </a-row>
            <template v-if="strategyMain.strategy_type === 'Cycle'">
              <a-form-model-item :label="$t('message.strategyStore.repeat')" prop="repeat">
                <a-select v-model="strategyMain.repeat" :disabled="onlyView" :options="repeatOpt" :size="$globalSize">
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('message.strategyStore.on')" prop="schedule_value">
                <div :class="{
                  disabled: onlyView || strategyMain.repeat === 'daily',
                }">
                  <a-checkable-tag v-for="tag in weekTagsOpt" v-model="tag.isChecked" :disabled="onlyView"
                    :key="tag.value" :title="tag.title()">
                    {{ tag.label() }}
                  </a-checkable-tag>
                </div>
              </a-form-model-item>

              <a-form-model-item :label="$t('message.strategyManagement.endDate')" prop="expiry_end_date">
                <a-date-picker :size="$globalSize" v-model="strategyMain.expiry_end_date" format="YYYY-MM-DD"
                  style="width: 100%" :disabled="onlyView" :disabledDate="disabledEndDate" />
              </a-form-model-item>
            </template>

            <a-form-model-item prop="">
              <span slot="label" class="no-required-text">
                {{ $t("message.strategyManagement.StartActivationStatus") }}
                <a-tooltip placement="topLeft" arrow-point-at-center>
                  <template slot="title">
                    {{
                      $t("message.strategyPushMgt.EnableDisableStrategyExecution")
                    }}</template>
                  <a-icon type="question-circle" />
                </a-tooltip>
              </span>
              <a-radio-group :size="$globalSize" :disabled="onlyView" style="width: 100%" v-model="strategyMain.status"
                @change="forceUpdate">
                <a-radio :value="1">{{ $t("message.commonUsage.yes") }}</a-radio>
                <a-radio :value="0">{{ $t("message.commonUsage.no") }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-form-model>
          <a-form :label-col="labelCol" :wrapper-col="wrapCol">
            <a-form-item>
              <span slot="label">
                <span class="need-required-text">*</span>{{ $t("message.strategyManagement.TargetAud") }}
              </span>
              <a-select :size="$globalSize" :disabled="onlyView || selectLoading" v-model="people" show-search
                placeholder="Select a person" option-filter-prop="children" :filter-option="filterOption"
                @change="peopleChgAdd" :loading="selectLoading">
                <a-select-option v-for="item in peoples" :key="item.value" :value="item.value" :title="item.value">
                  {{ item.label }} ({{ item.value }})
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <span slot="label" class="no-required-text">{{
                $t("message.userAnalysis.numberOfPeople")
                }}</span>

              <a-input :size="$globalSize" disabled v-model="people_number" :reverse="true" style="width: 50px" />
            </a-form-item>
          </a-form>
        </a-spin>
      </a-modal>
    </div>

    <!-- 行为 -->
    <action-mgt :strategyAction="strategyAction" ref="actionMgtRef" @refreshStrategyTable="refreshStrategyTable">
    </action-mgt>

    <a-modal :visible="showDelivered" title="Delivered Detail" @cancel="showDelivered = false" :footer="null">
      <a-table :pagination="false" :data-source="deliveredDetail" :loading="deliveredDetailLoading">
        <a-table-column title="No." key="no">
          <template slot-scope="text, record, index">
            {{ index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="Date" data-index="date" key="date" />
        <a-table-column title="Delivered" data-index="delivered" key="delivered" />
      </a-table>
      <my-pagination ref="deliveredPaginationRef" :total="deliveredTotal" :immediately="false"
        @change="getDeliveredDetail">
      </my-pagination>

    </a-modal>
  </div>
</template>

<script>
import utils from "@/utils";
import moment from "moment";
import launchStrategyService from "@/interface/pages/Strategy/launchStrategyService";
import userGroupListService from "@/interface/pages/UserGroup/userList";
import contentListService from "@/interface/pages/TxtManagement/contentListService";
import ActionMgt from "./components/ActionMgt.vue";
import MyPagination from "@/components/MyPagination";
import MyButton from "@/components/MyButton/index";
import { DateTime } from "luxon";
import { timeZoneConstant } from "@/utils/constant";

const strategyMainBackup = {
  repeat: "",
  schedule_value: "",
  schedule_value_arr: [],
  // 周期 单次
  strategy_type: "SingleTime",
  // 策略投放信息
  strategy_name: "",
  expiry_start_date: moment(),
  expiry_end_date: moment(),
  strategy_level_one_id: 1,
  strategy_level_two_id: 1,
  strategy_level_three_id: 1,
  time_zone: localStorage.getItem("time_zone"),
  segment_id: null,
  user_total_count: 0,
  priority_rank: 1,
  if_control: 1,
  control_rate: 0,
  is_auto: 0,
  strategy_level_parent_id: void 0,
  strategy_level_one_id: void 0,
  strategy_level_two_id: void 0,
  strategy_level_three_id: void 0,
  status: 1,
};
export default {
  name: "StrategyPushMgt",
  components: {
    ActionMgt,
    MyPagination,
    MyButton,
    MyPagination,
  },
  data() {
    return {
      reminderTimeOpt: [],
      deliveredDetail: [],
      deliveredDetailLoading: false,
      deliveredTotal: 0,
      timezoneList: timeZoneConstant.getTimeZoneList(),
      curMode: "add",
      labelCol: {
        span: localStorage.getItem("i18n").startsWith("zh") ? 6 : 8,
      },
      wrapCol: {
        span: localStorage.getItem("i18n").startsWith("zh") ? 16 : 14,
      },
      appModel: "2",

      strategyName: undefined,
      strategyId: undefined,
      strategyListLoading: false,
      autoid: 1,
      plainOptions: [
        { label: "SMS", value: 1 },
        { label: "Email", value: 2 },
      ],

      deliveryInformationRules: {
        strategy_id: [
          {
            required: true,
            message: () => this.$t("message.strategyStore.EnterStrategyID"),
            trigger: "change",
          },
        ],
        strategy_name: [
          {
            required: true,
            message: () => this.$t("message.strategyStore.enterStrategyName"),
            trigger: "change",
          },
        ],
        time_zone: [
          {
            required: true,
            message: () => this.$t("message.strategyStore.selectedTimezone"),
            trigger: "change",
          },
        ],
        expiry_start_date: [
          {
            required: true,
            message: () => this.$t("message.strategyStore.selectStartDate"),
            trigger: "change",
          },
        ],
        expiry_end_date: [
          {
            required: true,
            message: () => this.$t("message.strategyStore.selectEndDate"),
            trigger: "change",
          },
          {
            validator: (rule, value, callback) => {
              const startDate = this.strategyMain.expiry_start_date;
              if (
                startDate &&
                value &&
                moment(value).isBefore(moment(startDate))
              ) {
                callback(
                  new Error(this.$t("message.strategyStore.notBeEarlier"))
                );
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        repeat: [
          {
            required: true,
            message: () => this.$t("message.strategyStore.selectRepeat"),
            trigger: "change",
          },
        ],
        schedule_value: [
          {
            required: true,
            message: () => this.$t("message.strategyStore.selectOne"),
            trigger: "change",
          },
        ],
        strategy_type: [
          {
            required: true,
            message: () =>
              this.$t("message.strategyStore.periodicDeliverySelect"),
            trigger: "change",
          },
        ],
        // start_stop_id: [{ required: true, message: '请选择智能启停', trigger: 'change' }],
      },
      //t_stratege_main
      strategyMain: strategyMainBackup,
      strategyAction: {
        // 策略相关信息
        strategy_id: null,

        // 投放行为
        action_type: 1,
        action_name: "塞券",

        detail_id: null,
        detail_name: "",
        push_time: "",
        // push_with_coupon_suc: 1,
      },
      push_txts: [],
      throwVisible: false,
      people_number: 0,
      peoples: [],
      loading_step: false,
      people: undefined,
      pageTab: "all", //tab切换
      tableColumns: [
        {
          title: () => this.$t("message.strategyManagement.strategyLabel1"),
          dataIndex: "strategy_id",
          width: "180",
        },
        {
          title: () => this.$t("message.strategyManagement.strategyLabel2"),
          dataIndex: "strategy_name",
          width: "180",
          scopedSlots: { customRender: "strategy_name" },
        },
        {
          title: () => this.$t("message.strategyStore.timezone"),
          dataIndex: "time_zone",
          width: "180",
        },
        {
          title: () => this.$t("message.strategyPushMgt.StartEndDate"),
          dataIndex: "expiry_start_date",
          width: "260",
          scopedSlots: { customRender: "expiry_start_date" },
        },
        {
          title: () => this.$t("message.userGroupList.status"),
          dataIndex: "strategy_status",
          scopedSlots: { customRender: "strategy_status" },
        },
        // { title: '状态', scopedSlots: { customRender: 'if_valid' }, key: 'if_valid', dataIndex: 'if_valid' },
        {
          title: () => this.$t("message.userGroupList.audienceID"),
          dataIndex: "segment_id",
          width: "180",
        },
        {
          title: () => this.$t("message.strategyPushMgt.InProgressCount"),
          dataIndex: "user_total_count",
        },
        {
          title: () => this.$t("message.userGroupList.creator"),
          dataIndex: "created_user_name",
        },
        {
          title: () => this.$t("message.userGroupList.creationTime"),
          dataIndex: "created_time",
          scopedSlots: { customRender: "create_time" },
        },
        {
          title: () => this.$t("message.userGroupList.operation"),
          key: "op",
          scopedSlots: { customRender: "operation" },
          width: 150,
        },
        {
          title: () => {
            return (
              this.$t("message.userGroupList.disable") +
              "/" +
              this.$t("message.userGroupList.enable")
            );
          },
          align: "center",
          dataIndex: "status",
          key: "status",
          width: 150,
          scopedSlots: { customRender: "status" },
        },
      ], //表格列

      innerColumns: [
        { title: "ID", dataIndex: "id" },
        {
          title: () => this.$t("message.strategyPushMgt.DeliveryType"),
          dataIndex: "action_name",
        },
        {
          title: () => this.$t("message.strategyPushMgt.couponsCopywritingID"),
          dataIndex: "detail_id",
          ellipsis: true,
        },
        {
          title: () => this.$t("message.strategyPushMgt.DelivTitle"),
          dataIndex: "detail_name",
          ellipsis: true,
        },
        {
          title: () => this.$t("message.strategyPushMgt.PushTime"),
          dataIndex: "push_time",
          scopedSlots: { customRender: "push_time" },
        },
        {
          title: () => this.$t("message.strategyPushMgt.delivered"),
          dataIndex: "delivered",
          scopedSlots: { customRender: "delivered" },
        },

        {
          title: () => this.$t("message.userGroupList.operation"),
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: 170,
        },
      ],
      tableData: [], //表格数据
      tableTotalCount: 0,

      editWarmShow: false,
      editWarmForm: {
        // pushChannelList: [],
        // pushChannel: {},
        smsSignList: [],
        sms_sign: "",
        // 策略相关信息
        strategy_id: null,

        // 投放行为
        action_type: 1,
        action_name: "塞券",

        detail_id: null,
        detail_name: "",
        push_time: "",
      },
      textValue: undefined,

      valueTime: undefined,
      openTimePicker: false,
      repeatOpt: [
        { value: "daily", label: "Daily" },
        { value: "weekly", label: "Weekly" },
      ],
      weekTagsOpt: [
        {
          value: 6,
          label: () => this.$t("message.commonUsage.sunday"),
          isChecked: false,
          title: () => this.$t("message.strategyStore.sunday"),
        },
        {
          value: 0,
          label: () => this.$t("message.commonUsage.monday"),
          isChecked: false,
          title: () => this.$t("message.strategyStore.monday"),
        },
        {
          value: 1,
          label: () => this.$t("message.commonUsage.tuesday"),
          isChecked: false,
          title: () => this.$t("message.strategyStore.tuesday"),
        },
        {
          value: 2,
          label: () => this.$t("message.commonUsage.wednesday"),
          isChecked: false,
          title: () => this.$t("message.strategyStore.wednesday"),
        },
        {
          value: 3,
          label: () => this.$t("message.commonUsage.thursday"),
          isChecked: false,
          title: () => this.$t("message.strategyStore.thursday"),
        },
        {
          value: 4,
          label: () => this.$t("message.commonUsage.friday"),
          isChecked: false,
          title: () => this.$t("message.strategyStore.friday"),
        },
        {
          value: 5,
          label: () => this.$t("message.commonUsage.saturday"),
          isChecked: false,
          title: () => this.$t("message.strategyStore.saturday"),
        },
      ],
      isBefore: false,
      disabledSubmitBtn: false,
      curEditStrategy: {},
      // 标记打开编辑策略弹窗后，内容是否手动改变过，如果改变过，则可以给出日期判断的提示，否则隐藏提示
      isChanged: false,
      useCaseDetailLoading: false,
      actionListMap: {},
      curUseCase: {},
      showDelivered: false,
      selectLoading: false,
    };
  },
  computed: {
    onlyView: function () {
      return this.curMode === "view";
    },
    showTimeZoneWarning: function () {
      if (this.curMode === "view") {
        return false;
      } else if (this.curMode === "edit") {
        return this.isChanged && this.isBefore;
      } else {
        return this.isBefore;
      }
    },
  },
  mounted() {
    utils.languageChange(
      this,
      { labelCol: 8, wrapperCol: 14 },
      { labelCol: 6, wrapperCol: 16 }
    );
    this.initReminderTimeOpt();
  },

  watch: {
    autoid(v) {
      this.strategyMain.strategy_id = null;
    },
    weekTagsOpt: {
      handler() {
        this.strategyMain.schedule_value_arr = this.weekTagsOpt
          .filter((item) => item.isChecked)
          .map((item) => item.value);
        this.strategyMain.schedule_value = JSON.stringify(
          this.weekTagsOpt
            .filter((item) => item.isChecked)
            .map((item) => item.value)
        );
      },
      deep: true,
      immediate: true,
    },
    "strategyMain.repeat": {
      handler(v) {
        if (v === "daily") {
          this.selectAllWeekTags();
        } else {
          if (!this.strategyMain.id) {
            this.initWeekTagsOpt();
          }
        }
      },
    },
    // 单独监听 strategyMain.time_zone
    "strategyMain.time_zone": {
      handler() {
        this.handleTimeZoneChange();
      },
    },
    // 单独监听 strategyMain.expiry_start_date
    "strategyMain.expiry_start_date": {
      handler() {
        this.handleTimeZoneChange();
      },
    },
    throwVisible: {
      handler(v) {
        this.isChanged = false;
        this.isBefore = false;
        this.disabledSubmitBtn = false;
      },
    },
  },
  methods: {
    getDeliveredDetail() {
      this.deliveredDetailLoading = true;
      const params = {
        action_id: this.curUseCase.action_id,
        ...this.$refs.myPaginationRef.pagination,
      }

      launchStrategyService.getActionPushDetailById(this, { params, }).then(
        function (response) {
          let res = response.data;
          if (res.code == "200") {
            this.deliveredDetail = res.data;
            this.deliveredTotal = res.totalCount;
          } else {
            if (res.code !== '400') {
              this.$message.error(res.message);
            }
          }
          this.deliveredDetailLoading = false;

        }.bind(this)
      )
        .catch((response) => {
          this.$message.error(response);
        }).finally(() => {
          this.deliveredDetailLoading = false;

        });
    },
    showDeliveredModal(record) {
      this.curUseCase = record;
      this.showDelivered = true;
      this.getDeliveredDetail();
    },
    // 禁用
    disabledBtn(record) {
      var that = this;
      this.$confirm({
        title:
          record.is_disabled == 1
            ? this.$t("message.userGroupList.enableThisUseCaseConfirm")
            : this.$t("message.userGroupList.disableThisUseCaseConfirm"),
        okText: this.$t("message.userGroupList.confirm"),
        okType: "primary",
        cancelText: this.$t("message.userGroupList.cancel"),
        onOk() {
          return new Promise((resolve, reject) => {
            that.disabledConfirm(record, resolve, reject);
          });
        },
        onCancel() {
          that.$message.warning(
            record.is_disabled
              ? that.$t("message.userGroupList.enableThisAudienceCancel")
              : that.$t("message.userGroupList.disableThisAudienceCancel")
          );
        },
      });
    },
    disabledConfirm(record, resolve, reject) {
      let data = {
        ...record,
        status: record.status == 0 ? 1 : 0,
      };
      data.expiry_start_date =
        moment(this.strategyMain.expiry_start_date).format("YYYY-MM-DD") +
        " 00:00:00";

      if (data.strategy_type === "SingleTime") {
        data.expiry_end_date = data.expiry_start_date.replace(
          "00:00:00",
          "23:59:59"
        );
      } else {
        data.expiry_end_date =
          moment(this.strategyMain.expiry_end_date).format("YYYY-MM-DD") +
          " 23:59:59";
      }
      launchStrategyService
        .updStrategy(this, { data })
        .then((response) => {
          let res = response.data;
          if (res.code == 200) {
            this.$message.success(res.message);
            this.$refs.deliveryInformationRuleForm &&
              this.$refs.deliveryInformationRuleForm.resetFields();
            this.strategyMain.strategy_id = null;
            setTimeout(() => {
              this.throwVisible = false;
              this.loading_step = false;
              this.pageTab = "all";
              this.getStrategyList();
            }, 1000);
            resolve();
          } else {
            this.loading_step = false;
            if (res.code !== '400') {
              this.$message.error(res.message);
            }
            reject();
          }
        })
        .catch((error) => {
          this.loading_step = false;
          this.$message.error(error);
          reject();
        });
    },
    disabledEndDate(current) {
      const startDate = this.strategyMain.expiry_start_date;
      if (startDate) {
        const startMoment = moment(startDate, "YYYY-MM-DD");
        return current && current < startMoment.endOf("day");
      }
      return false;
    },
    initReminderTimeOpt() {
      const options = [];
      for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 15) {
          const h = hour.toString().padStart(2, "0");
          const m = minute.toString().padStart(2, "0");
          const time = `${h}:${m}`;
          options.push({
            label: time,
            value: time,
          });
        }
      }
      this.reminderTimeOpt = options;
    },
    // 处理 strategyMain.time_zone 变化
    handleTimeZoneChange() {
      this.isChanged = true;
      console.log("handleTimeZoneChange");
      if (
        !this.strategyMain.time_zone ||
        !this.strategyMain.expiry_start_date
      ) {
        return;
      }

      try {
        // 获取指定时区当前时间
        const currentDate = DateTime.local({
          zone: this.strategyMain.time_zone,
        });

        let expiryStartISO;
        if (this.strategyMain.expiry_start_date instanceof moment) {
          // 如果是 Moment 对象，转换为 ISO 格式字符串
          expiryStartISO = this.strategyMain.expiry_start_date.toISOString();
        } else {
          // 如果是字符串，直接使用
          expiryStartISO = this.strategyMain.expiry_start_date;
        }

        // 确保日期格式包含时间信息
        if (!expiryStartISO.includes("T")) {
          expiryStartISO = `${expiryStartISO}T00:00:00`;
        }

        // 获取到的日期是当地时区格式的日期
        const selectedDate = DateTime.fromISO(expiryStartISO).startOf("day");
        // 获取年月日
        const { year, month, day } = selectedDate;
        // 转化为所选时区的日期
        const selectedDay = DateTime.local(year, month, day, {
          zone: this.strategyMain.time_zone,
        });
        const currentDay = currentDate.startOf("day");
        this.isBefore = selectedDay < currentDay;
        this.disabledSubmitBtn = selectedDay < currentDay;
      } catch (error) {
        console.error("处理时间时区时出错:", error);
      }
    },
    //添加行为之后关闭弹窗，刷新页面
    refreshStrategyTable() {
      this.pageTab = "all";
      this.getStrategyList();
      this.expandRow(true, this.curUseCase)
    },

    forceUpdate() {
      this.$forceUpdate();
    },
    removeCompletely(record) {
      let _self = this;
      this.$confirm({
        title: this.$t("message.commonUsage.deleteConfirmMsg"),
        okText: this.$t("message.commonUsage.delete"),
        okType: "primary",
        cancelText: this.$t("message.commonUsage.cancel"),
        onOk() {
          return new Promise(function (resolve, reject) {
            _self.delStrategyBack(record.strategy_id, resolve, reject);
          });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    },
    async delStrategyBack(id, resolve = () => { }, reject = () => { }) {
      try {
        let params = {
          strategy_id: id,
        };
        const { data: res } = await launchStrategyService
          .delStrategyBack(this, { params })
        if (res.code == "200") {
          this.$message.success(res.message);
          this.getStrategyList();
          resolve();
        } else {
          if (res.code !== '400') {
            this.$message.error(res.message);
          }
          reject();
        }
      } catch (error) {
        this.$message.error(error);
        reject();
      }

    },
    addAction(record) {
      this.strategyAction.action_name = "塞券";
      this.strategyAction.action_type = 1;
      this.strategyAction.strategy_id = record.strategy_id;
      this.curUseCase = record;
      this.strategyAction.id = 0;

      this.strategyAction.detail_id = "";
      this.strategyAction.detail_name = "";
      this.strategyAction.time_zone = record.time_zone;
      this.strategyAction.expiry_start_date = record.expiry_start_date;
      this.strategyAction.strategy_type = record.strategy_type;

      this.$refs.actionMgtRef.showModal();
    },
    handleActionTimeChange() {
      this.isChanged = true;

      console.log("handleActionTimeChange");
      if (
        !this.curEditStrategy.time_zone ||
        !this.curEditStrategy.expiry_start_date ||
        this.curEditStrategy.strategy_type == "Cycle"
      ) {
        return;
      }

      try {
        // 获取用户当前系统时间
        const currentDate = DateTime.local({
          zone: this.curEditStrategy.time_zone,
        });
        // 获取策略开始日期
        let expiryStartISO = this.curEditStrategy.expiry_start_date;
        // 如果日期格式中不包含 'T'，则添加当前时间信息
        if (!expiryStartISO.includes("T")) {
          // 修正：使用正确的日期变量和格式
          expiryStartISO =
            this.curEditStrategy.expiry_start_date +
            `T${this.editWarmForm.push_time}:00`;
        }
        console.log(expiryStartISO);
        const selectedDate = DateTime.fromISO(expiryStartISO).setZone(
          this.curEditStrategy.time_zone
        );
        console.log("🚀 ~ handleTimeZoneChange ~ selectedDate:", selectedDate);
        console.log("🚀 ~ handleTimeZoneChange ~ currentDate:", currentDate);

        // 将时分秒设置到 selectedDate 中
        this.isBefore = selectedDate < currentDate;
        this.disabledSubmitBtn = selectedDate < currentDate;
      } catch (error) {
        console.error("处理时间时区时出错:", error);
      }
    },
    editBehavior(record, option, mode = "edit") {
      //编辑
      this.curUseCase = record
      this.curMode = mode;
      this.editWarmForm = {};
      this.disabledSubmitBtn = false;
      this.isBefore = false;

      this.textValue = {
        key: record.detail_id,
        label: record.detail_name + "(" + record.detail_id + ")",
      };
      this.valueTime = moment(record.push_time, "HH:mm");
      this.editWarmShow = true;

      // c
      this.editWarmForm = JSON.parse(JSON.stringify(record));

      this.editWarmForm.id = record.id;
      this.editWarmForm.strategy_id = option.strategy_id;
      this.curEditStrategy = { ...option };
      if (record.action_name) {
        this.queryAll(record.action_name, record.is_auto, "edit");
      }
    },
    deleteBehavior(record) {
      this.curUseCase = record
      var that = this;
      this.$confirm({
        title: this.$t("message.commonUsage.delete"),
        okText: this.$t("message.commonUsage.delete"),
        okType: "primary",
        cancelText: this.$t("message.commonUsage.cancel"),
        onOk() {
          return new Promise((resolve, reject) => {
            let body = { id: record.id };
            launchStrategyService
              .delStrategyActionById(that, { data: body })
              .then((response) => {
                let res = response.data;
                if (res.code == 200) {
                  that.$message.success(res.message);
                  that.getStrategyList();
                  that.expandRow(true, that.curUseCase);
                  resolve();
                } else {
                  that.$message.error(res.message);
                  reject();
                }
              })
              .catch((error) => {
                console.log("查询失败！" + error);
                reject();
              });
          });
        },
        onCancel() {
          that.$message.warning(that.$t("message.txtManagement.txtMgtMsg4"));
        },
      });
    },
    getFormatDate(arg) {
      if (arg == undefined || arg == "") {
        return "";
      }
      let re = arg + "";
      if (re.length < 2) {
        re = "0" + re;
      }
      return re;
    },
    queryAll(search, is_auto, val) {
      this.push_txts = [];
      let name = {
        channel: search.toLowerCase(),
        is_auto,
      };
      contentListService
        .getAllContentList(this, { params: name })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              this.push_txts = res.data;
            } else {
              if (res.code !== '400') {
                this.$message.error(res.message);
              }
            }
          }.bind(this)
        )
        .catch((reponse) => {
          console.log(reponse);
        });
    },
    initWeekTagsOpt() {
      this.weekTagsOpt = this.weekTagsOpt.map((item) => {
        item.isChecked = false;
        return item;
      });
    },
    selectAllWeekTags() {
      this.weekTagsOpt = this.weekTagsOpt.map((item) => {
        item.isChecked = true;
        return item;
      });
    },
    addActivity() {
      this.strategyMain = { ...strategyMainBackup };
      this.initWeekTagsOpt();
      this.userGroupList()
      this.people = null;
      this.people_number = 0;
      this.autoid = 1;
      this.curMode = "add";
      this.throwVisible = true;
    },
    // 查询列表数据
    userGroupList() {
      this.selectLoading = true;
      let body = {};
      userGroupListService
        .userGroupListOption(this, { params: body })
        .then((response) => {
          let res = response.data;
          if (res.code == 200) {
            this.peoples = res.data;
          } else {
            if (res.code !== '400') {
              this.$message.error(res.message);
            }
          }
          this.selectLoading = false;
        })
        .catch((error) => {
          console.log("查询失败！" + error);
        }).finally(() => {
          this.selectLoading = false;
        });
    },
    async expandRow(expanded, record) {
      try {
        this.$set(record, 'loadingExpanded', true);
        const params = { strategy_id: record.strategy_id };
        const { data: res } = await launchStrategyService
          .getStrategyAction(this, { params })
        if (res.code == 200) {
          this.$set(this.actionListMap, record.strategy_id, res.data);
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error(error.message || error);
      } finally {
        this.$set(record, 'loadingExpanded', false);
      }
    },
    async editActivity(record, mode = "edit") {
      try {
        this.curMode = mode;
        this.throwVisible = true;
        this.useCaseDetailLoading = true;
        const { data: res } = await launchStrategyService
          .getStrategyDetail(this, { params: { strategy_id: record.strategy_id } })

        if (res.code == 200) {
          this.strategyMain = { ...res.data };
          const schedule_value = JSON.parse(res.data.schedule_value);
          const arr = [];
          this.weekTagsOpt.forEach((item) => {
            arr.push({ ...item, isChecked: schedule_value.includes(item.value) });
          });
          this.weekTagsOpt = arr;

          this.people = res.data.segment_id;
          this.peopleChgAdd(res.data.segment_id);

        } else {
          this.$message.error(res.message);
        }
        this.useCaseDetailLoading = false;
      } catch (error) {
        this.$message.error(error);
        this.useCaseDetailLoading = false;
      }
    },
    delActivity(record) {
      var that = this;
      this.$confirm({
        title: this.$t("message.strategyManagement.operateTip4"),
        okText: this.$t("message.commonUsage.delete"),
        okType: "primary",
        cancelText: this.$t("message.commonUsage.cancel"),
        onOk() {
          return new Promise((resolve, reject) => {
            let body = {
              id: record.id,
              loginId: localStorage.getItem("userId"),
            };
            launchStrategyService
              .delStrategy(that, { params: body })
              .then((response) => {
                let res = response.data;
                if (res.code == 200) {
                  that.$message.success(res.message);
                  resolve();
                  that.$store.dispatch('fetchButtonPermission')
                  that.getStrategyList();
                } else {
                  that.$message.error(res.message);
                  reject();
                }
              })
              .catch((error) => {
                reject();
                that.$message.error(error);
              });
          });
        },
        onCancel() {
          that.$message.warning(that.$t("message.txtManagement.txtMgtMsg4"));
        },
      });
    },


    // 查询策略列表
    getStrategyList() {
      this.strategyListLoading = true;
      const params = {
        tabName: this.pageTab,
        ...this.$refs.myPaginationRef.pagination,
      }
      this.strategyId && (params.strategyId = this.strategyId);
      this.strategyName && (params.strategyName = this.strategyName);
      launchStrategyService
        .getStrategyList(this, {
          params,
        })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              this.tableData = res.data;
              this.tableTotalCount = res.totalCount;
              this.strategyListLoading = false;
            } else {
              if (res.code !== '400') {
                this.$message.error(res.message);
              }
            }
          }.bind(this)
        )
        .catch((response) => {
          this.$message.error(response);
        });
    },

    moment,

    showTime(value, formate) {
      let type = formate || "yyyy-MM-dd";
      if (typeof value == "undefined" || value == null || value == "") {
        return "-";
      }
      return utils.formatDate(new Date(value), type);
    },
    showStatus(record) {
      let status = "";
      switch (record.strategy_status) {
        case "0":
          status = this.$t("message.strategyPushMgt.Stopped");
          break;
        case "1":
          status = this.$t("message.strategyPushMgt.InProgress");
          break;
        case "2":
          status = this.$t("message.strategyPushMgt.Expired");
          break;
        case "3":
          status = this.$t("message.strategyPushMgt.ToBeStarted");
          break;
        case "4":
          status = this.$t("message.strategyPushMgt.AlreadyDeleted");
          break;
      }
      return status;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onSearch() {
      this.$refs.myPaginationRef.initCurrent();
      this.getStrategyList();
    },
    handleOk7(e) {
      this.$refs.deliveryInformationRuleForm.validate((valid) => {
        if (valid) {
          // 手动输入ID判断
          if (this.autoid === 0 && !this.strategyMain.strategy_id) {
            return this.$message.warning(
              this.$t("message.strategyStore.pleaseEnterStrategyID")
            );
          }

          //新建活动保存
          if (!this.people) {
            return this.$message.warning(
              this.$t("message.strategyManagement.SelectTargetAudience")
            );
          }
          this.saveStrategy();
        } else {
          return false;
        }
      });
    },
    peopleChgAdd(value) {
      this.peoples.some((element) => {
        if (element.value == value) {
          this.people_number = element.user_count;

          this.strategyMain.user_total_count = element.user_count;
          this.strategyMain.segment_id = element.value;
        }
      });
    },
    // 策略原表单数据处理
    handleStrategyData() {
      let data = "";
      data = JSON.parse(JSON.stringify(this.strategyMain));
      data.strategy_level_id = this.strategyMain.strategy_level_three_id;
      // 如果if_control = 0
      if (data.if_control == 2) {
        data.control_rate = 0;
      }
      if (!data.strategy_id) {
        data.strategy_id = null;
      }
      data.priority_rank = this.strategyMain.priority_rank;

      return data;
    },
    saveStrategy() {
      this.loading_step = true;
      let data = this.handleStrategyData();
      let func = launchStrategyService.createStrategy;
      // id=0 while create strategy
      data.id = 0;
      if (this.curMode === "edit") {
        data.id = this.strategyMain.id;
        func = launchStrategyService.updStrategy;
      }

      data.expiry_start_date =
        moment(this.strategyMain.expiry_start_date).format("YYYY-MM-DD") +
        " 00:00:00";

      if (data.strategy_type === "SingleTime") {
        data.expiry_end_date = data.expiry_start_date.replace(
          "00:00:00",
          "23:59:59"
        );
      } else {
        data.expiry_end_date =
          moment(this.strategyMain.expiry_end_date).format("YYYY-MM-DD") +
          " 23:59:59";
      }

      delete data.if_control;
      delete data.is_auto;
      delete data.strategy_id;
      delete data.schedule_value_arr;
      // 新的请求策略接口
      func(this, { data })
        .then((response) => {
          let res = response.data;
          if (res.code == 200) {
            this.$message.success(res.message);
            this.$refs.deliveryInformationRuleForm &&
              this.$refs.deliveryInformationRuleForm.resetFields();
            this.strategyMain.strategy_id = null;
            setTimeout(() => {
              this.throwVisible = false;
              this.loading_step = false;
              this.pageTab = "all";
              this.$store.dispatch('fetchButtonPermission')
              this.getStrategyList();
            }, 1000);
          } else {
            this.loading_step = false;
            if (res.code !== '400') {
              this.$message.error(res.message);
            }
          }
        })
        .catch((error) => {
          this.loading_step = false;
          this.$message.error(error);
        });
    },
    async saveStrategyAction() {
      let data = {};
      //更新 提醒
      data = JSON.parse(JSON.stringify(this.editWarmForm));
      data.detail_id = this.textValue.key;
      data.detail_name = this.textValue.label;

      const { data: res } = await launchStrategyService.saveStrategyAction(
        this,
        { data: data }
      );
      if (res.code == 200) {
        this.$message.success(res.message);
        this.editWarmShow = false;
        this.getStrategyList();
        this.$store.dispatch('fetchButtonPermission')
        this.expandRow(true, this.curUseCase);
      } else {
        if (res.code !== '400') {
          this.$message.error(res.message);
        }
      }
    },
    tabChangeXun(val) {
      //多选 但是传给后端只取第一个 新增
      let tab_value = val[0];
      this.strategyAction.detail_id = tab_value.key;
      let label = tab_value.label;
      let index = label.indexOf("(");
      this.strategyAction.detail_name = label.slice(0, index);
    },
    txtFilterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>

<style scoped>
.no-required-text {
  padding-left: 11px;
}

.need-required-text {
  display: inline-block;
  color: #f5222d;
  width: 12px;
}

#strategyManagementModal ::v-deep .ant-card-bordered {
  border: 1px black solid;
}

.icon {
  font-size: 30px;
  color: #ffbc0d;
}

.add-btn {
  margin-left: 10px;
  cursor: pointer;
  color: rgb(255, 188, 13);
  font-size: 18px;
}

.add-btn:hover {
  color: rgba(255, 188, 13, 0.6);
}

.radio-container>>>.ant-radio-wrapper {
  margin-bottom: 10px;
}

.btn-container {
  display: flex;
  justify-content: flex-end;
}

.classification-modification {
  margin-right: 20px;
}

.event-type-tab>>>.ant-radio-button-wrapper {
  border: 1px solid #d8d8d8;
}

.event-type-tab>>>.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #000000;
  background: #e7e7e7;
  border: 1px solid #e7e7e7;
}

.event-type-tab>>>.ant-radio-button-wrapper-disabled {
  background: #fff;
}

.event-type-text {
  width: 200px;
  text-align: center;
}

.filter-rule>>>.ant-form-item-control-wrapper {
  margin-top: 8px;
}

.rule-text {
  color: rgba(0, 0, 0, 0.65);
}

.tfxw-container>>>.ant-radio-button-wrapper {
  height: 120px;
  width: 166px;
  padding-top: 30px;
  text-align: center;
  margin-right: 14px;
  background: #f0f0f0;
  border: none;
  color: #000000;
}

.tfxw-container>>>.ant-radio-group label span {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tfxw-container ::v-deep .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {
  color: var(--font-color);
  background-color: var(--main-color);
  border: none;
}

.tfxw-container ::v-deep .ant-radio-button-wrapper:not(:first-child)::before {
  background-color: transparent;
}

.title-name {
  font-weight: bold;
  color: #000000;
}

.inline-block {
  display: flex;
}

.ant-checkbox-wrapper+.ant-checkbox-wrapper {
  margin-left: 0;
}

.ant-tag-checkable {
  background-color: #ccc;
  color: #fff;
  font-weight: bolder;
  width: 40px;
  height: 40px;
  cursor: pointer;
  line-height: 40px;
  font-size: 16px;
  text-align: center;
}

.ant-tag-checkable-checked {
  background-color: var(--main-color);
  font-weight: bolder;
  width: 40px;
  height: 40px;
  cursor: pointer;
  line-height: 40px;
  font-size: 16px;
  text-align: center;
}

.disabled {
  pointer-events: none;
}
</style>
